import React from 'react';
import './CartItemName.less';

export const CartItemName = ({name}) => {
	return <span className="cart-item-name">{name}</span>;
};
